import { PAGINATION_ITEMS_PER_PAGE } from "../../../../../config/constants";
import { WasteFormValues } from "../types/wasteRecords.types";

export { PAGINATION_ITEMS_PER_PAGE };

export const DEFAULT_FORM_VALUES: WasteFormValues = {
  streamName: "",
  managementType: "",
  distribution: "",
  distributionUnit: "kg",
  ingredientName: "",
  moisture: ""
};
